import { useTranslation } from 'react-i18next';
import { Form } from '@anytag/shared-atoms';
import { useAllCountryOptions } from '@anytag/shared-hooks';
import { SelectorField, TextSearchField } from '@anytag/shared-molecules';
import { useEngagementStatusOptions } from '../hooks';
import { AdvancedFilter } from './AdvancedFilter';
import { EngagementCampaignsFilterFormKeys } from './schemaTypes';
interface BasicFilterProps {
  onSubmit?: () => void;
}

export const BasicFilter = ({ onSubmit }: BasicFilterProps) => {
  const { t } = useTranslation();
  const { allCountryOptions } = useAllCountryOptions();
  const { engagementStatusOptions } = useEngagementStatusOptions();

  return (
    <Form.Fields>
      <TextSearchField<EngagementCampaignsFilterFormKeys>
        name="keyword"
        onSubmit={onSubmit}
        placeholder={t<string>('Search.EngagementFilter')}
      />

      <SelectorField<EngagementCampaignsFilterFormKeys>
        name="status"
        onSubmit={onSubmit}
        className="max-w-40"
        options={engagementStatusOptions}
        placeholder={t<string>('Selector.Status')}
      />

      <SelectorField<EngagementCampaignsFilterFormKeys>
        name="countryIds"
        onSubmit={onSubmit}
        options={allCountryOptions}
        className="max-w-40"
        placeholder={t<string>('Selector.Countries')}
        multiple
      />

      <AdvancedFilter onSubmit={onSubmit} />
    </Form.Fields>
  );
};
